export type { EcotrapPageProps } from "./EcotrapPage";
export { EcotrapPage } from "./EcotrapPage";
